<template>
  <div>
    <div class="container" style="padding-top:20px;" v-if="!status && isShow">
      <div style="padding: 0 20px;margin-bottom:20px;display: flex;align-items:center;">

        <h2>发票申请</h2>

      </div>

      <div v-html="desc" style="text-align:left;padding:0 20px;margin-top:20px;margin-bottom:20px">

      </div>

      <van-form @submit="onSubmit" label-align='left'>
        <!-- 自定义表单 -->
        <van-field v-model="form.company" required name="机构名称" label="机构名称" placeholder="机构名称" />
        <van-field v-model="form.phone" required name="联系电话" label="联系电话" placeholder="联系电话" />
        <van-field v-model="form.email" required name="联系邮箱" label="联系邮箱" placeholder="联系邮箱" />
        <van-field v-model="form.bankNo" required name="开户银行" label="开户银行" placeholder="开户银行" />
        <van-field v-model="form.companyNo" required name="纳税人识别号" label="纳税人识别号" placeholder="纳税人识别号" />
        <div style="margin: 16px;">
          <van-button round block type="info" native-type="submit">提交</van-button>
        </div>
      </van-form>
    </div>

    <div v-if='status && isShow' style="text-align:center;padding: 120px 30px 0 30px; ">
      <!-- <img src="../../../public/images/bigRight.png" alt="" style="width:64px;height:64px;"> -->
      <div style="font-size: 22px;font-weight: 500;color: #2F2F2F;margin-top:15px;margin-bottom:35px;">
        申请成功
      </div>

      <div style="font-size: 14px;font-weight: 500;color: #2F2F2F;">
        提交成功后，我们会将电子发票发送至您的邮箱。
      </div>

      <!-- <div style="width: 85vw;height: 50px;border-radius: 25px;border: 1px solid #03A64D;position:fixed;bottom: 100px;font-size: 16px;font-weight: 400;color: #fff;text-align:center;line-height:50px;background: #03A64D;" @click="goBackHome()">
        确认
      </div> -->

    </div>

  </div>

</template>


<script>
import { noTokenQuestionnaireAdd, checkSubmitNaire } from '../../api/questionApi'
import { getOrderDetail } from '../../api/customPageApi'
import { GetQueryString } from '@/utils/utils'
import formValite from '@/utils/form'
export default {
  name: 'visitorRegister',
  data() {
    return {
      form: {
        sex: 1,
      },
      desc: `提交成功后，我们会将电子发票发送至您的邮箱。`,
      cascaderValue: '',
      show: false,
      starIcon: 'https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/MEHZ/images/needForm.png',
      options: [],
      isRegister: false, // 是否注册
      isShow: false,
      isHaveUserInfo: false, //用户是否有实名信息
      showPicker: false,
      status: false,
      submitFlag: false,
    }
  },
  created() {
    document.title = '发票申请'
    this.isShow = true
  },
  methods: {
    onSubmit(e) {
      console.log(e, this.customFiledArr)
      if (this.submitFlag) {
        return false
      }
      if (this.$isEmpty(this.form.company)) {
        this.$toast('机构名称不能为空')
        return false
      }
      if (this.$isEmpty(this.form.phone)) {
        this.$toast('联系电话不能为空')
        return false
      }
      if (this.$isEmpty(this.form.email)) {
        this.$toast('联系邮箱不能为空')
        return false
      }
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      if (!emailRegex.test(this.form.email)) {
        this.$toast('邮箱格式不正确')
        return false
      }
      if (this.$isEmpty(this.form.bankNo)) {
        this.$toast('开户银行不能为空')
        return false
      }
      if (this.$isEmpty(this.form.companyNo)) {
        this.$toast('纳税人识别号不能为空')
        return false
      }

      let formContentArr = [
        {
          questionValue: this.form.company,
          questionName: '机构名称',
          type: 'text',
        },
        {
          questionValue: this.form.phone,
          questionName: '联系电话',
          type: 'text',
        },
        {
          questionValue: this.form.email,
          questionName: '联系邮箱',
          type: 'text',
        },
        {
          questionValue: this.form.bankNo,
          questionName: '开户银行',
          type: 'text',
        },
        {
          questionValue: this.form.companyNo,
          questionName: '纳税人识别号',
          type: 'text',
        },
      ]

      // formContentArr = formValite.handleFormAttendKeyByQuestion(formContentArr, this.customFiledArr)

      const data = {
        feedbackCode: `Q1780907275016232960`,
        feedbackContent: JSON.stringify(formContentArr),
        feedbackName: '发票申请',
      }

      var headerClientInfo = { language: 'CN', eventKey: 'WeMeet', appKey: 'WX_MINI_WEMEET' }
      let headers = {
        'x-call-client-info': JSON.stringify(headerClientInfo),
      }

      noTokenQuestionnaireAdd(headers, data).then((res) => {
        console.log(res)
        // this.checkStatus()
        if (res.code == 200) {
          this.submitFlag = false
          this.status = true
        } else {
          this.submitFlag = false
          this.$toast.fail(res.msg)
        }
      })
    },
  },
}
</script>


<style lang="less" scoped>
.container {
  background: #fafafa;
  min-height: 100vh;
  .title {
    font-size: 14px;
    line-height: 16px;
    padding: 32px 16px 16px;
    color: rgba(69, 90, 100, 0.6);
    text-align: left;
  }
}
</style>


<style lang='less'>
.van-checkbox__label {
  width: 80vw;
}
.van-radio__label {
  width: 80vw;
}
.vantAreaCell {
  padding: 0 16px 10px 16px;
  &.van-cell::after {
    display: none;
  }
}
.van-field__body {
  height: 100%;
}

.vanCell {
  display: block;
  text-align: left;
  .van-field__left-icon {
    display: inline-block;
    line-height: 1;
    position: relative;
    left: -10px;
  }
  .van-field__label {
    display: inline-block;
    width: 80vw;
    position: relative;
    left: -10px;
    margin-bottom: 20px;
  }
}
</style>